<template>
  <v-row>
    <v-col cols="12" class="pt-0">
      <Title
        text-start
        :font-weight="600"
        :font-size="14"
        title="Документ об образовании"
        append-icon="mdi-trash-can-outline"
        @click:append-outer="removeEducation"
      />
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-model="education.educationDocType"
        :items="dictionaries.educationDocType"
        item-text="name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setEducation"
      >
        <template #label>
          <span class="required">Тип документа</span>
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12" md="6"  class="py-0">
      <v-text-field
        v-model="education.series"
        placeholder="Введите данные"
        rounded
        outlined
        dense
        @input="setEducation"
      >
        <template #label>
          <span class="required">Серия</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" md="6"  class="py-0">
      <v-text-field
        v-model="education.number"
        placeholder="Введите данные"
        rounded
        outlined
        dense
        @input="setEducation"
      >
        <template #label>
          <span class="required">Номер</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" md="6"  class="py-0">
      <DatePicker
        label="Дата выдачи"
        required
        :prop-date="education.issueDate"
        @set-date="setIssueDate"
      />
    </v-col>

    <v-col cols="12" class="pt-0">
      <FileInput
        title="Файл документа об образовании"
        :ref-id="education.id"
        ref-class-name="Education"
        @set-files="setFiles"
      />
    </v-col>
  </v-row>
</template>

<script>
import Title from '@/components/ui/Title'
import DatePicker from '@/components/ui/DatePicker'
import FileInput from '@/components/ui/FileInput'
import {Education} from "@/models"
import {mapGetters} from "vuex";

export default {
  name: "Education",

  components: {
    Title,
    DatePicker,
    FileInput
  },

  props: {
    item: Education
  },

  data: () => ({
    education: new Education()
  }),

  computed: {
    ...mapGetters('dictionaries', ['dictionaries'])
  },

  methods: {
    setEducation() {
      this.$emit('set-data', this.education)
    },

    removeEducation() {
      this.$emit('remove', this.education)
    },

    setIssueDate(value) {
      this.education.issueDate = value
      this.setEducation()
    },

    setFiles(value) {
      this.education.filesData = value
      this.setEducation()
    }
  },

  watch: {
    'item': {
      deep: true,
      immediate: true,
      handler() {
        this.education = Education.build(this.item)
      }
    }
  }
}
</script>

<style scoped>
</style>
